<template>
  <v-tooltip location="top" :open-on-click="true">
    <template v-slot:activator="{ props }">
      <!-- v2's `icon small` was a 28px transparent button with a dark glyph;
           without variant="text" Vuetify 3 fills the circle and inverts it -->
      <v-btn
        color="text"
        icon
        variant="text"
        size="28"
        class="mr-2 mb-1"
        v-bind="props"
      >
        <v-icon size="24">mdi-information-outline</v-icon>
      </v-btn>
    </template>
    <span>
      Inclusive of taxes where provided local taxes may also be charged in
      destinations
    </span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'TaxToolTip'
};
</script>
